
import { Component, Vue } from 'vue-property-decorator'
import { notification } from 'ant-design-vue'
import axios from 'axios'
import UserSetting from '@/types/userSetting'
import ls from '@/ls'

const O365_REDIRECT_STORAGE_KEY = 'o365LoginRedirect'

@Component({
  components: {}
})

export default class O365LoginSucceeded extends Vue {
  loading = false

  created () : void {
    const token = this.$route.query.token as string
    this.loading = true

    this.$store.dispatch('authStore/getDetailsForO365User', { token }).then(() => {
      this.getUserSettings()
      this.redirect()
    }).catch(() => {
      notification.error({ message: 'Fout tijdens inloggen!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.' })
      this.$router.push({ name: 'login' })
    }).finally(() => {
      this.loading = false
    })
  }

  getUserSettings () : void {
    axios.get(process.env.VUE_APP_API_URL + '/users/admin/settings').then((res) => {
      if (res.data.length) {
        res.data.forEach((setting:UserSetting) => {
          ls.set(setting.setting_name, setting.setting_value)
        })
      }
    })
  }

  redirect () : void {
    const redirectPath = this.getSafeRedirectPath()
    ls.remove(O365_REDIRECT_STORAGE_KEY)

    if (redirectPath) {
      this.$router.push(redirectPath)
      return
    }

    this.$router.push({ name: 'dashboard' })
  }

  getSafeRedirectPath () : string | null {
    const redirect = ls.get(O365_REDIRECT_STORAGE_KEY)
    if (typeof redirect !== 'string') {
      return null
    }

    if (!redirect.startsWith('/') || redirect.startsWith('//') || redirect.includes('://')) {
      return null
    }

    return redirect
  }
}
